import { render, staticRenderFns } from "./clientCommon.vue?vue&type=template&id=afa53974&scoped=true&"
import script from "./clientCommon.vue?vue&type=script&lang=js&"
export * from "./clientCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa53974",
  null
  
)

export default component.exports